import { Navigate, useOutletContext, useParams } from 'react-router-dom'

export function CustomerIndex() {
  const { customerId } = useParams()
  const { categories } = useOutletContext()
  if (!categories?.length) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white/90 p-8 shadow-sm">
        <p className="text-brand-muted">No categories available for this customer.</p>
      </div>
    )
  }
  return <Navigate to={`/customers/${customerId}/${categories[0].slug}`} replace />
}
